import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';
import { Settings } from '@core/types/settings';

@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MembershipComponent implements OnInit {

  public contentHeader: object;
  public transactions: any = []
  public selectBasic = [];
  currentPlan: any

  public user: any
  public siteSettings: Settings;
  submitted: boolean = false
  disable: boolean = false
  old_pin: any
  new_pin: any;

  constructor(
    private tokenStorage: TokenStorageService,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {
    
  }

  subscribe(plan) {
    this.submitted = true
    this.disable = true
    const param = {
      currentPlan: this.currentPlan,
      newPlan: plan
    }
    this.api.post('upgrade-membership', param).subscribe((response: any) => {
      this.submitted = false
      this.disable = false
      if (response.success === true) {
        this.api.alerts("top-end", "success", response.message)
        this.tokenStorage.saveUser(response.customer);
        window.location.reload()
      }else{
        this.api.alerts("top-end", "error", response.message)
      }
    });
    
  }

  ngOnInit(): void {

    this.api.externalGet('list-membership-plans').subscribe((response: any) => {
      this.selectBasic = response.data.plans;
      this.currentPlan = response.data.current_plan;
    });
    
    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
    }

    this._coreConfigService.sysConfig().subscribe(config => {
      console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    // content header
    this.contentHeader = {
      headerTitle: 'Upgrade Membership',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'Account Membership',
            isLink: false
          }
        ]
      }
    };

  }

}
